import React, { useState, useEffect } from "react";
import styles from "./ChristmasSaleHeroV2.module.scss";
import { useNavigate } from 'react-router-dom';
import Base from "images/heros/ChristmasSaleV2/Winter-scene-base-min.jpg";
import welcome from "images/heros/ChristmasSaleV2/Winter-scene-welcome-min.jpg";
import tvparty from "images/heros/ChristmasSaleV2/Winter-scene-tvparty-min.jpg";
import christmas from "images/heros/ChristmasSaleV2/Winter-scene-christmas-min.jpg";
import newyear from "images/heros/ChristmasSaleV2/Winter-scene-newyear-min.jpg";
import OutlineText from "../../Utlility/OutlineText/OutlineText";

const ChristmasSaleHeroV2 = () => {
    const navigate = useNavigate();

    const now = new Date();
    const isChristmas = now.getMonth() === 11 && (now.getDate() < 26 || (now.getDate() === 26 && now.getHours() < 8));

    const images = [welcome, tvparty, isChristmas ? christmas : newyear];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFlashing, setIsFlashing] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            setIsFlashing(true);
        }, 4000);
        return () => clearInterval(timer);
    }, []);

    const handleAnimationEnd = () => {
        setIsFlashing(false);
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    return (
        <div className={styles.heroContainer}>
            <div className={styles.imageStack}>
                <img
                    src={Base}
                    alt="Winter scene base"
                    className={styles.heroImage}
                />
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className={`${styles.heroImage} ${styles.overlayImage} ${index === currentIndex ? styles.visible : ''} ${index === currentIndex && isFlashing ? styles.flashing : ''}`}
                        onAnimationEnd={index === currentIndex ? handleAnimationEnd : undefined}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChristmasSaleHeroV2;